import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client/react';
import { apolloClient } from './lib/apollo';
import { App } from './App';
import { watchSystemMode } from './lib/theme';
import './globals.css';
import './theme-skins.css';

// Live-follow the OS light/dark while in "system" mode (index.html did first paint).
watchSystemMode();

// LOCAL DEV ONLY, OPT-IN — Theme Lab panel (⌥T). Off unless VITE_THEME_LAB=true is in
// apps/web/.env.local, so `pnpm dev` and local e2e runs get no floating button. `vite build`
// gives DEV=false (unless NODE_ENV=development is forced), so the branch and its dynamic
// import are dropped; the sandbox and prod CI jobs also fail if ThemeLab is in `dist`.
if (import.meta.env.DEV && import.meta.env.VITE_THEME_LAB === 'true') {
  void import('./dev/ThemeLab').then((m) => m.mountThemeLab());
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

createRoot(rootEl).render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </StrictMode>,
);
